module.exports = __webpack_public_path__ + "static/media/feishu_video.2e81c4eb.png";